export const AVATAR_API = "https://ui-avatars.com/api";
export const API = process.env.REACT_APP_API_URL;
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
